<template>
  <div>
    <div class="input-group">
      <input
        v-model="new_item"
        type="text"
        class="form-control"
        :placeholder="placeholder"
        aria-label="Recipient's username"
        aria-describedby="basic-addon2"
        @keyup.enter="addItem"
      />

      <div class="input-group-append">
        <button class="no-bg" type="button" @click="addItem">
          <img :src="select_icon" alt="" />
        </button>
      </div>
    </div>

    <div class="badge-container">
      <div v-for="(item, index) in items">
        <span>
          <label class="badge">
            <span>{{ item }}</span>
            <span role="button" @click="removeTag(index)"
              ><img :src="remove_badge" alt=""
            /></span>
          </label>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import SelectIcon from "../../../../../../../public/common/select.svg";
import RemoveBadgeIcon from "../../../../../../../public/common/remove-badge.svg";
import { mapState } from "vuex";
export default {
  name: "ChanelInput",
  props: {
    placeholder: String,
    type: String,
  },
  data() {
    return {
      new_item: "",
      select_icon: SelectIcon,
      remove_badge: RemoveBadgeIcon,
      items: [],
    };
  },
  computed: {
    ...mapState("investor_configuration", ["create_action_config"]),
  },
  mounted() {
    let index = this.create_action_config.channels.findIndex(
      (obj) => obj["channel_type"] == this.type
    );
    this.items =
      index != -1 ? this.create_action_config.channels[index].addresses : [];
  },
  methods: {
    addItem() {
      this.items.push(this.new_item);
      this.new_item = "";
      this.emitItems();
    },
    removeTag(index) {
      this.items.splice(index, 1);
      this.emitItems();
    },
    emitItems() {
      this.$emit("changed", { addresses: this.items, channel_type: this.type });
    },
  },
};
</script>
